export default {
  title: 'Vytvoriť zdroj dát',
};
